import { App } from "./kernel/kernel";
import Router from "./kernel/core/router";
import Backbone from "backbone";
import raf from "raf";
import "scss/init.scss"

window.API_ROOT = "";

/**
 * Monkey patch the router
 */
const loadUrl = Backbone.History.prototype.loadUrl;

Backbone.History.prototype.loadUrl = function() {
    const routeSuccessfullyFired = loadUrl.apply(this, arguments);
    
    if (!routeSuccessfullyFired) {
        System.import("domain/views/not-found/not-found").then(View => {
            const view = new View.default();
            raf(_ => App.contentRegion.show(view));
        });
    }
};

App.start();

const demonstrateColourChange = () => {
    const colors = [
        "#2FBA89",
        "#f5ab35"
    ];
    
    const getRandomColour = () => {
        return colors[Math.floor(Math.random() * colors.length)]    
    };
    
    window.setInterval(function() {
        document.querySelector("head").querySelector(`[name="theme-color"]`).setAttribute("content", getRandomColour());
    }, 500);
};

// demonstrateColourChange();



// WEBPACK FOOTER //
// ./public/main.js